import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  constructor(private titleService: Title, private metaService: Meta) {}

  setSeoData(title: string, description: string, image: string) {
    this.titleService.setTitle(`${title}`);
    this.metaService.updateTag({
      name: 'description',
      content: description,
    });
    // Twitter
    this.metaService.updateTag({
      property: 'twitter:card',
      content: 'summary_large_image',
    });
    this.metaService.updateTag({
      property: 'twitter:title',
      content: title,
    });
    this.metaService.updateTag({
      property: 'twitter:description',
      content: description,
    });
    this.metaService.updateTag({
      property: 'twitter:image',
      content: image,
    });
    // Facebook
    this.metaService.updateTag({
      property: 'og:url',
      content: window.location.href,
    });
    this.metaService.updateTag({ property: 'og:type', content: 'website' });
    this.metaService.updateTag({
      property: 'og:description',
      content: description,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: title,
    });
    this.metaService.updateTag({
      property: 'og:image',
      content: image,
    });
  }
}
